var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcManageLocations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  fillRule: "evenodd",
  d: "M14 15v-2h1v3h-4v2h-1v-3h4ZM21 16v2h1v-3h-4v-2h-1v3h4Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C7CDDD",
  d: "M12.5 5.5h7v7h-7zM6.5 18.5h7v7h-7zM18.5 18.5h7v7h-7z"
})));
export { SvgIcManageLocations as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxNVYxM0gxNVYxNVYxNkgxMVYxOEgxMFYxNlYxNUgxNFoiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxNlYxOEgyMlYxNlYxNUgxOFYxM0gxN1YxNVYxNkgyMVoiIGZpbGw9IiNDN0NEREQiLz4KPHJlY3QgeD0iMTIuNSIgeT0iNS41IiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiBzdHJva2U9IiNDN0NEREQiLz4KPHJlY3QgeD0iNi41IiB5PSIxOC41IiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiBzdHJva2U9IiNDN0NEREQiLz4KPHJlY3QgeD0iMTguNSIgeT0iMTguNSIgd2lkdGg9IjciIGhlaWdodD0iNyIgc3Ryb2tlPSIjQzdDREREIi8+Cjwvc3ZnPgo=";